import './SectionTextView.css';
export default {
    "wrapper": "SectionTextView_wrapper__13w2z",
    "title": "SectionTextView_title__13w2z",
    "content": "SectionTextView_content__13w2z"
};
